import axios from "axios";

/**
 *
 * @param {String} accessToken
 * @param {String} refreshToken
 * @param {String} comeFrom
 * @returns Promise
 */
const logout = async (accessToken, refreshToken, comeFrom) => {
  return await axios
    .post("/api/auth/logout", { accessToken, refreshToken, comeFrom });
};

export {
  logout
};
